import React, { useContext, useEffect, useMemo, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useGetUsersDeviceQuery } from "../../../Redux/service/Devices";
import { useGetAllDriversQuery } from "../../../Redux/service/DriversTraccar/DriversTraccar";
import { useLocation } from "react-router-dom";
import { useGetSpecificCustomUserQuery } from "../../../Redux/service/Users/CustomUsers";
import { ConfigProvider, DatePicker, Space, Select as SelectAntd } from "antd";
import { Input as AntdInput } from "antd";
import {
	useGetCategoriesListQuery,
	useGetSubCategoriesListQuery,
} from "../../../Redux/service/InventorySetup/InventorySetup";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

import dayjs from "dayjs";
import trans from "../../../utils";
import { useGetGroupsQuery } from "../../../Redux/service/Groups/Groups";
import { popupcontext } from "../../../context/Popupscontext";
import { useGetAllGeofencesQuery } from "../../../Redux/service/Geofences/Geofences";
import { useGetDevicesByGroupQuery } from "../../../Redux/service/Groups/GroupsBack";
import { useSelector } from "react-redux";
import { useGetAllUsersQuery } from "../../../Redux/service/Users/Users";
const { TextArea } = AntdInput;
const { RangePicker } = DatePicker;

export function Input({
	title,
	type,
	placeholder,
	onBlur,
	onChange,
	id,
	name,
	formstyle,
	value,
	errors,
	touched,
	disabled,
	min,
	max,
	step,
	addonAfter,
	addonBefore,
}) {
	const FormError = errors && touched ? "form-error" : "";

	return (
		<>
			<div className={`position-relative ${formstyle} ${FormError}`}>
				<label className="form-label text-capitalize">{title}</label>
				{type !== "password" ? (
					<AntdInput
						type={type}
						placeholder={placeholder}
						onBlur={onBlur}
						onChange={onChange}
						value={value}
						id={id}
						name={name}
						disabled={disabled}
						min={min}
						max={max}
						addonBefore={addonBefore}
						addonAfter={addonAfter}
						onKeyDown={(e) => {
							if (type === "number")
								if (
									e.key === "e" ||
									e.key === "E" ||
									e.key === "+" ||
									e.key === "-"
								) {
									e.preventDefault();
								}
						}}
					/>
				) : (
					<AntdInput.Password
						type={type}
						placeholder={placeholder}
						onBlur={onBlur}
						onChange={onChange}
						value={value}
						id={id}
						name={name}
						disabled={disabled}
						min={min}
						max={max}
						iconRender={(visible) =>
							visible ? (
								<EyeTwoTone color="#2e9245" twoToneColor="#2e9245" />
							) : (
								<EyeInvisibleOutlined color="#2e9245" twoToneColor="#2e9245" />
							)
						}
					/>
				)}
				<div>
					{errors && touched ? (
						<div className="validation">{trans(errors)}</div>
					) : (
						""
					)}
				</div>
			</div>
		</>
	);
}

export function InputDate({
	title,
	type,
	placeholder,
	onBlur,
	onChange,
	id,
	name,
	formstyle,
	value,
	errors,
	touched,
	disabled,
	min,
	max,
	step,
	showTime,
	minTime,
	maxDate,
}) {
	const FormError = errors && touched ? "form-error" : "";
	const dateValue = useMemo(() => {
		return value ? dayjs(value) : null;
	}, [value]);

	return (
		<>
			<div className={`position-relative form-input ${formstyle} ${FormError}`}>
				<label className="form-label text-capitalize">{title}</label>
				<Space>
					<DatePicker
						type={type}
						onBlur={onBlur}
						onChange={onChange}
						disabledDate={(current) => {
							if (min) {
								return current && current < dayjs(min).startOf("day");
							}
							return false;
						}}
						value={dateValue}
						placeholder={trans("Select Date")}
						id={id}
						name={name}
						disabled={disabled}
						min={min}
						max={max}
						className={FormError}
						showTime={showTime || undefined}
						disabledTime={(current) => {
							if (minTime && current && current.isSame(dayjs(minTime), "day")) {
								const minMoment = dayjs(minTime);
								return {
									disabledHours: () => {
										const hours = [];
										for (let h = 0; h < minMoment.hour(); h++) {
											hours.push(h);
										}
										return hours;
									},
									disabledMinutes: (selectedHour) => {
										if (selectedHour === minMoment.hour()) {
											const minutes = [];
											for (let m = 0; m < minMoment.minute(); m++) {
												minutes.push(m);
											}
											return minutes;
										}
										return [];
									},
								};
							}
							return {};
						}}
						maxDate={maxDate}
					/>
				</Space>
				<div>
					{errors && touched ? (
						<div className="validation">{trans(errors)}</div>
					) : (
						""
					)}
				</div>
			</div>
		</>
	);
}

export function DatePickerInputNew({
	title,
	formstyle,
	errors,
	touched,
	onChange,
	variant,
	rangeStyle,
	startDate,
	endDate,
	value,
}) {
	let { pathname } = useLocation();
	const FormError = errors && touched ? "form-error" : "";
	const getYearMonth = (date) => date.year() * 12 + date.month();
	const getShortPath = () => pathname.split("/").pop();
	const getPath = pathname.split("/");
	const disabled7DaysDate = (current, { from, type }) => {
		if (from) {
			if (
				getShortPath(pathname) === "historical" ||
				getPath[1] === "historyplayback" ||
				getShortPath(pathname) === "vehiclestrips" ||
				getShortPath(pathname) === "route"
			) {
				const minDate = from.add(-4, "days");
				const maxDate = from.add(4, "days");

				switch (type) {
					case "year":
						return (
							current.year() < minDate.year() || current.year() > maxDate.year()
						);

					case "month":
						return (
							getYearMonth(current) < getYearMonth(minDate) ||
							getYearMonth(current) > getYearMonth(maxDate)
						);

					default:
						return Math.abs(current.diff(from, "days")) >= 4;
				}
			}
		}

		return false;
	};
	const handleDateChange = (dates) => {
		if (dates && dates.length === 2) {
			const [startDate, endDate] = dates;
			if (onChange) {
				onChange({ startDate, endDate });
			}
		}
	};
	const dateFormat = "YYYY-MM-DD HH:mm:ss";

	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError}`}>
				<label className="form-label">{title}</label>
				<ConfigProvider
					theme={{
						token: {
							colorPrimary: "#0f6936",
							activeBg: "#0f6936",
							activeBorderColor: "#2e9245",
						},
					}}
				>
					<RangePicker
						showTime
						onChange={handleDateChange}
						size="large"
						disabledDate={disabled7DaysDate}
						defaultValue={
							startDate && endDate
								? [dayjs(startDate, dateFormat), dayjs(endDate, dateFormat)]
								: ""
						}
						placeholder={[trans("Start Date"), trans("End Date")]}
						variant={variant}
						className={rangeStyle}
					/>
				</ConfigProvider>
				<div>
					{errors && touched ? <div className="validation">{errors}</div> : ""}
				</div>
			</div>
		</>
	);
}

export function DatePickerInput({
	title,
	formstyle,
	errors,
	touched,
	onChange,
	variant,
	rangeStyle,
	startDate,
	endDate,
	value,
	disabled,
}) {
	let { pathname } = useLocation();
	const FormError = errors && touched ? "form-error" : "";
	const getYearMonth = (date) => date.year() * 12 + date.month();
	const getShortPath = () => pathname.split("/").pop();
	const getPath = pathname.split("/");
	const disabled7DaysDate = (current, { from, type }) => {
		if (from) {
			if (
				getShortPath(pathname) === "historical" ||
				getPath[1] === "historyplayback" ||
				getShortPath(pathname) === "vehiclestrips" ||
				getShortPath(pathname) === "route"
			) {
				const minDate = from.add(-4, "days");
				const maxDate = from.add(4, "days");

				switch (type) {
					case "year":
						return (
							current.year() < minDate.year() || current.year() > maxDate.year()
						);

					case "month":
						return (
							getYearMonth(current) < getYearMonth(minDate) ||
							getYearMonth(current) > getYearMonth(maxDate)
						);

					default:
						return Math.abs(current.diff(from, "days")) >= 4;
				}
			}
		}

		return false;
	};
	const handleDateChange = (dates) => {
		if (dates && dates.length === 2) {
			const [startDate, endDate] = dates;
			if (onChange) {
				onChange({ startDate, endDate });
			}
		}
	};
	const dateFormat = "YYYY-MM-DD HH:mm:ss";

	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError}`}>
				<label className="form-label">{title}</label>
				<ConfigProvider
					theme={{
						token: {
							colorPrimary: "#0f6936",
							activeBg: "#0f6936",
							activeBorderColor: "#2e9245",
						},
					}}
				>
					<RangePicker
						showTime
						onChange={handleDateChange}
						disabledDate={disabled7DaysDate}
						defaultValue={
							startDate && endDate
								? [dayjs(startDate, dateFormat), dayjs(endDate, dateFormat)]
								: ""
						}
						variant={variant}
						className={rangeStyle}
						placeholder={[trans("Start Date"), trans("End Date")]}
						disabled={disabled || false}
						value={
							value
								? [dayjs(value[0], dateFormat), dayjs(value[1], dateFormat)]
								: null
						}
					/>
				</ConfigProvider>
				<div>
					{errors && touched ? (
						<div className="validation">{trans(errors)}</div>
					) : (
						""
					)}
				</div>
			</div>
		</>
	);
}

export function InputVehicleGroup({
	id,
	name,
	onChange,
	onBlur,
	errors,
	touched,
	formstyle,
	value,
}) {
	const FormError = errors && touched ? "form-error" : "";
	const vehicleOptions = [
		{
			label: trans("Commercial Vehicles"),
			options: [
				{ label: trans("Delivery Trucks"), value: "Delivery Trucks" },
				{ label: trans("Cargo Vans"), value: "Cargo Vans" },
				{ label: trans("Utility Trucks"), value: "Utility Trucks" },
			],
		},
		{
			label: trans("Passenger Vehicles"),
			options: [
				{ label: trans("Sedans"), value: "Sedans" },
				{ label: trans("Suvs"), value: "Suvs" },
				{ label: trans("Vans"), value: "Vans" },
			],
		},
		{
			label: trans("Specialized Vehicles"),
			options: [
				{ label: trans("Ambulances"), value: "Ambulances" },
				{ label: trans("Police Cars"), value: "Police Cars" },
				{ label: trans("Fire Trucks"), value: "Fire Trucks" },
				{
					label: trans("Construction Vehicles"),
					value: "Constructions Vehicles",
				},
			],
		},
		{
			label: trans("Public Transportation Vehicles"),
			options: [
				{ label: trans("Buses"), value: "Buses" },
				{ label: trans("Shuttles"), value: "Shuttles" },
			],
		},
		{
			label: trans("Heavy-Duty Vehicles"),
			options: [
				{ label: trans("Trucks"), value: "Trucks" },
				{ label: trans("Trailers"), value: "Trailers" },
			],
		},
		{
			label: trans("Special Purpose Vehicles"),
			options: [
				{ label: trans("Refrigerated Trucks"), value: "Refrigerated Trucks" },
				{ label: trans("Tanker Trucks"), value: "Tanker Trucks" },
				{ label: trans("Tow Trucks"), value: "Tow Trucks" },
			],
		},
		{
			label: trans("Construction Off-Road Vehicles"),
			options: [
				{ label: trans("Excavators"), value: "Excavators" },
				{ label: trans("Bulldozers"), value: "Bulldozers" },
				{ label: trans("Off-Road Vehicles"), value: "Off-Road Vehicles" },
			],
		},
		{
			label: trans("Electric Vehicles (EVs)"),
			options: [
				{ label: trans("Electric Cars"), value: "Electric Cars" },
				{ label: trans("Electric Trucks"), value: "Electric Trucks" },
				{ label: trans("Electric Vans"), value: "Electric Vans" },
			],
		},
	];
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError} `}>
				<label className="form-label">{trans("Vehicle type")}</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={trans("Select Vehicle Type")}
						value={value && value.length ? value : undefined}
						id={id}
						name={name}
						onBlur={onBlur}
						options={vehicleOptions}
						allowClear
						showSearch
						status={touched && (!value || value.length === 0) ? "error" : ""}
						onChange={(value) => onChange(name, value)}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}

export function InputCountriesGroup({
	id,
	name,
	onChange,
	onBlur,
	errors,
	touched,
	formstyle,
	value,
}) {
	const FormError = errors && touched ? "form-error" : "";
	const countryOptions = [
		{
			label: trans("North America"),
			options: [
				{ label: trans("Canada"), value: "canada" },
				{ label: trans("USA"), value: "usa" },
				{ label: trans("Mexico"), value: "mexico" },
			],
		},
		{
			label: trans("South America"),
			options: [
				{ label: trans("Brazil"), value: "brazil" },
				{ label: trans("Argentina"), value: "argentina" },
			],
		},
		{
			label: trans("Europe"),
			options: [
				{ label: trans("France"), value: "france" },
				{ label: trans("Germany"), value: "germany" },
				{ label: trans("Italy"), value: "italy" },
				{ label: trans("Spain"), value: "spain" },
				{ label: trans("UK"), value: "uk" },
				{ label: trans("Belgium"), value: "belgium" },
				{ label: trans("Netherlands"), value: "netherlands" },
				{ label: trans("Portugal"), value: "portugal" },
				{ label: trans("Sweden"), value: "sweden" },
				{ label: trans("Russia"), value: "russia" },
			],
		},
		{
			label: trans("Asia"),
			options: [
				{ label: trans("China"), value: "china" },
				{ label: trans("India"), value: "india" },
				{ label: trans("Japan"), value: "japan" },
				{ label: trans("South Korea"), value: "korea-south" },
				{ label: trans("Taiwan"), value: "taiwan" },
				{ label: trans("Turkey"), value: "turkey" },
			],
		},
		{
			label: trans("Oceania"),
			options: [{ label: trans("Australia"), value: "australia" }],
		},
	];
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError} `}>
				<label className="form-label">{trans("Manfacture country")}</label>

				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={trans("Select Vehicle Type")}
						value={value && value.length ? value : undefined}
						id={id}
						name={name}
						onBlur={onBlur}
						options={countryOptions}
						allowClear
						showSearch
						status={touched && (!value || value.length === 0) ? "error" : ""}
						onChange={(value) => onChange(name, value)}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}

export function InputFuelGroup({
	id,
	name,
	onChange,
	onBlur,
	errors,
	touched,
	formstyle,
	value,
}) {
	const FormError = errors && touched ? "form-error" : "";
	const fuelOptions = [
		{
			label: trans("Type"),
			options: [
				{ label: trans("Gas"), value: "Gas" },
				{ label: trans("Diesel"), value: "Diesel" },
				{ label: trans("Sollar"), value: "Sollar" },
			],
		},
	];
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError} `}>
				<label className="form-label">{trans("Fuel Type")}</label>

				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={trans("Select Vehicle Type")}
						value={value && value.length ? value : undefined}
						id={id}
						name={name}
						onBlur={onBlur}
						options={fuelOptions}
						allowClear
						showSearch
						status={touched && (!value || value.length === 0) ? "error" : ""}
						onChange={(value) => onChange(name, value)}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}

export function InputParentGroup({
	title,
	id,
	name,
	onChange,
	onBlur,
	errors,
	touched,
	value,
	formstyle,
	mode,
}) {
	//const inf = useSelector((state) => state.users.user);
	const FormError = errors && touched ? "form-error" : "";
	const { data } = useGetAllUsersQuery();

	const parentOptions = data
		? [
				{
					label: trans("users"),
					options: data?.map((user) => ({
						label: user?.name,
						value: user?.id,
					})),
				},
			]
		: [];
	//const selectedUser = data?.find((user) => user.id === value);
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError}`}>
				<label className="form-label text-capitalize">{title}</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						mode={mode && "multiple"}
						maxTagCount="responsive"
						placeholder={trans("Select Parent")}
						value={value && value ? value : ""}
						id={id}
						name={name}
						onBlur={onBlur}
						options={parentOptions}
						allowClear
						showSearch
						status={touched && (!value || value.length === 0) ? "error" : ""}
						onChange={onChange}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>

				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}

export function InputDevicesGroup({
	title,
	id,
	name,
	onChange,
	onBlur,
	errors,
	touched,
	value,
	formstyle,
	userID,
	mode,
}) {
	//const inf = useSelector((state) => state.users.user);
	const FormError = errors && touched ? "form-error" : "";
	const { data } = useGetDevicesByGroupQuery(userID, { skip: !userID });
	const [devicesOptions, setDevicesOptions] = useState([]);

	useEffect(() => {
		if (!userID || !data) {
			setDevicesOptions([]);
			return;
		}

		const options = data.map((device) => ({
			label: device.name,
			value: device.id,
		}));

		setDevicesOptions([
			{
				label: trans("Vehicles"),
				options: options,
			},
		]);
	}, [data, userID]);
	console.log("devicesOptions", devicesOptions);
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError}`}>
				<label className="form-label">{title}</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						mode={mode && "multiple"}
						maxTagCount="responsive"
						placeholder={trans("Select Vehicle")}
						value={value && value ? value : undefined}
						id={id}
						name={name}
						onBlur={onBlur}
						options={devicesOptions}
						allowClear
						showSearch
						status={touched && (!value || value.length === 0) ? "error" : ""}
						onChange={onChange}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}
export function InputDriversGroup({
	id,
	name,
	onChange,
	onBlur,
	errors,
	touched,
	value,
	formstyle,
}) {
	const FormError = errors && touched ? "form-error" : "";
	const { data } = useGetAllDriversQuery();
	const driversOptions = data
		? [
				{
					label: trans("drivers"),
					options: data?.map((driver) => ({
						label: driver.name,
						value: driver.id,
					})),
				},
			]
		: [];
	const selectedDriver = data?.find((driver) => driver.id === value);

	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError} `}>
				<label className="form-label">Driver</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={trans("Select Vehicle Type")}
						value={value && value.length ? selectedDriver : undefined}
						id={id}
						name={name}
						onBlur={onBlur}
						options={driversOptions}
						allowClear
						showSearch
						onChange={onChange}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}

export function InputsGeofence({
	id,
	name,
	onChange,
	onBlur,
	errors,
	touched,
	value,
	formstyle,
}) {
	const FormError = errors && touched ? "form-error" : "";
	const { data } = useGetAllGeofencesQuery();
	const geoOptions = data
		? [
				{
					label: trans("geofences"),
					options: data?.map((geo) => ({
						label: geo.name,
						value: geo.id,
					})),
				},
			]
		: [];

	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError} `}>
				<label className="form-label">Geofences</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={trans("Select Geofences")}
						value={value && value.length ? value : undefined}
						id={id}
						name={name}
						onBlur={onBlur}
						options={geoOptions}
						allowClear
						showSearch
						onChange={onChange}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}

export function Switch({ id, name, onBlur, onChange, value, disabled }) {
	return (
		<>
			<label className={`switch`}>
				<input
					className="form-control"
					type="checkbox"
					id={id}
					name={name}
					onChange={onChange}
					onBlur={onBlur}
					value={value}
					checked={value ? true : false}
					autoFocus
					disabled={disabled}
				/>
				<span className="slider round"></span>
			</label>
		</>
	);
}

export function Sensors({
	title,
	vehicleInf,
	id,
	name,
	onBlur,
	onChange,
	value,
}) {
	return (
		<>
			<div className={`sensors mb-16`}>
				<div className="flex-between mb-8">
					<div className="fs-16 fw-500 neutral-500 text-capitalize">
						{vehicleInf
							? trans(`${title} support`)
							: trans(`${title} sensor support`)}
					</div>
					<div className="y-25">
						<Switch
							id={id}
							name={name}
							onChange={onChange}
							onBlur={onBlur}
							value={value}
						/>
					</div>
				</div>
				<div className={vehicleInf ? "" : "H-line-2"}></div>
			</div>
		</>
	);
}

export function PaginationCounter({ onBlur, onChange, value }) {
	return (
		<div>
			<select
				className="form-select decorated"
				id="paginationcounter"
				name="paginationcounter"
				onChange={onChange}
			>
				<option value={10}>10</option>
				<option value={20}>20</option>
				<option value={30}>30</option>
				<option value={40}>40</option>
				<option value={50}>50</option>
				<option value={60}>60</option>
				<option value={70}>70</option>
				<option value={80}>80</option>
				<option value={90}>90</option>
				<option value={100}>100</option>
			</select>
		</div>
	);
}

export function InputSpeedUnit({
	id,
	name,
	onChange,
	onBlur,
	formstyle,
	value,
	touched,
	errors,
}) {
	const FormError = errors && touched ? "form-error" : "";

	const speedOptions = [
		{
			label: trans("Unit"),
			options: [
				{ label: trans("kn"), value: "kn" },
				{ label: trans("km/h"), value: "kmh" },
				{ label: trans("mph"), value: "mph" },
			],
		},
	];
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError}`}>
				<label className="form-label">{trans("Speed Unit")}</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={trans("Select Speed Unit")}
						value={value && value.length ? value : undefined}
						id={id}
						name={name}
						onBlur={onBlur}
						options={speedOptions}
						allowClear={false}
						showSearch
						onChange={onChange}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}

export function InputDistanceUnit({
	id,
	name,
	onChange,
	onBlur,
	formstyle,
	value,
	errors,
	touched,
}) {
	const FormError = errors && touched ? "form-error" : "";

	const distanceOptions = [
		{
			label: trans("Unit"),
			options: [
				{ label: trans("km"), value: "km" },
				{ label: trans("mi"), value: "mi" },
				{ label: trans("nmi"), value: "nmi" },
			],
		},
	];
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError}`}>
				<label className="form-label">{trans("Distance Unit")}</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={trans("Select Distance Unit")}
						value={value && value.length ? value : undefined}
						id={id}
						name={name}
						onBlur={onBlur}
						options={distanceOptions}
						allowClear={false}
						showSearch
						onChange={onChange}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}

export function InputAltitudeUnit({
	id,
	name,
	onChange,
	onBlur,
	formstyle,
	value,
	errors,
	touched,
}) {
	const FormError = errors && touched ? "form-error" : "";

	const altitudeOptions = [
		{
			label: trans("Unit"),
			options: [
				{ label: trans("m"), value: "m" },
				{ label: trans("ft"), value: "ft" },
			],
		},
	];
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError}`}>
				<label className="form-label">{trans("Altitude Unit")}</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={trans("Select Altitude Unit")}
						value={value && value.length ? value : undefined}
						id={id}
						name={name}
						onBlur={onBlur}
						options={altitudeOptions}
						allowClear={false}
						showSearch
						onChange={onChange}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}

export function InputVolumeUnit({
	id,
	name,
	onChange,
	onBlur,
	formstyle,
	value,
	errors,
	touched,
}) {
	const FormError = errors && touched ? "form-error" : "";

	const volumeOptions = [
		{
			label: trans("Unit"),
			options: [
				{ label: trans("liter"), value: "ltr" },
				{ label: trans("U.S. Gallon"), value: "usGal" },
				{ label: trans("IMP. Gallon"), value: "impGal" },
			],
		},
	];
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError}`}>
				<label className="form-label">{trans("Volume Unit")}</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={trans("Select Altitude Unit")}
						value={value && value.length ? value : undefined}
						id={id}
						name={name}
						onBlur={onBlur}
						options={volumeOptions}
						allowClear={false}
						showSearch
						onChange={onChange}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}
export function InputGeofenceStatus({
	id,
	name,
	onChange,
	onBlur,
	formstyle,
	value,
	errors,
	touched,
}) {
	const FormError = errors && touched ? "form-error" : "";
	const geoOptions = [
		{
			label: trans("Select Geofence Status"),
			options: [
				{ label: trans("Allowed"), value: "#2e9245" },
				{ label: trans("Not Allowed"), value: "red" },
			],
		},
	];
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError} `}>
				<label className="form-label">{trans("Geofence Status")}</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={trans("Select Vehicle Type")}
						value={value && value.length ? value : undefined}
						id={id}
						name={name}
						onBlur={onBlur}
						options={geoOptions}
						allowClear
						showSearch
						status={touched && (!value || value.length === 0) ? "error" : ""}
						onChange={onChange}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>
			</div>
			<div>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}
export function UsersSwitch({ onBlur, formstyle, onChange, value }) {
	const inf = useSelector((state) => state.users.user);
	const [selectedRole, setSelectedRole] = useState({
		deviceReadonly: false,
		readonly: false,
	});

	// Effect: set default based on admin status
	useEffect(() => {
		if (value && inf.administrator) {
			setSelectedRole({
				deviceReadonly: !!value.deviceReadonly,
				readonly: !!value.readonly,
			});
		} else if (
			!inf.administrator &&
			inf.deviceReadonly === false &&
			inf.readonly === false
		) {
			// Force default to readonly for non-admins
			setSelectedRole({
				deviceReadonly: false,
				readonly: true,
			});
		}
	}, [value, inf.administrator, inf.deviceReadonly, inf.readonly]);

	const handleChange = (e) => {
		const { name, checked } = e.target;

		// Admins can deselect all — others can't
		if (inf.administrator) {
			setSelectedRole((prev) => ({
				...prev,
				[name]: checked,
				// if selecting one, disable the other
				[name === "deviceReadonly" ? "readonly" : "deviceReadonly"]: checked
					? false
					: prev[name === "deviceReadonly" ? "readonly" : "deviceReadonly"],
			}));
		} else {
			// Non-admins must always have one role
			if (!checked) return; // block unchecking
			setSelectedRole({
				deviceReadonly: name === "deviceReadonly",
				readonly: name === "readonly",
			});
		}

		if (onChange) {
			// Uncheck the opposite on change
			onChange({
				target: {
					name,
					value: checked,
				},
			});
			onChange({
				target: {
					name: name === "deviceReadonly" ? "readonly" : "deviceReadonly",
					value: false,
				},
			});
		}
	};

	return (
		<div className={`position-relative ${formstyle}`}>
			<label className="form-label">{trans("role")}</label>
			<div className="d-block">
				{/* Fleet Operator */}
				<div className="d-flex align-content-center mb-2">
					<label className="switch">
						<input
							type="checkbox"
							name="deviceReadonly"
							onChange={handleChange}
							onBlur={onBlur}
							checked={selectedRole.deviceReadonly}
						/>
						<span className="slider round" />
					</label>
					<div className="switch-archive-label">{trans("Fleet Operator")}</div>
					<img
						src={`${process.env.PUBLIC_URL}/assets/information.svg`}
						alt="info"
						title={trans(
							"ordinary user with a restriction on vehicle manipulation",
						)}
					/>
				</div>

				{/* Fleet Observer */}
				<div className="d-flex align-content-center">
					<label className="switch">
						<input
							type="checkbox"
							name="readonly"
							onChange={handleChange}
							onBlur={onBlur}
							checked={selectedRole.readonly}
						/>
						<span className="slider round" />
					</label>
					<div className="switch-archive-label">{trans("Fleet Observer")}</div>
					<img
						src={`${process.env.PUBLIC_URL}/assets/information.svg`}
						alt="info"
						title={trans(
							"a user that cannot add/edit/remove anything in the system. They can only monitor their assigned objects.",
						)}
					/>
				</div>
			</div>
		</div>
	);
}

export function MultiSelectOld({
	options,
	defaultValue,
	errors,
	touched,
	title,
	onChange,
	onBlur,
	setSelected,
	value,
}) {
	const FormError = errors && touched ? "form-error" : "";

	const animatedComponents = makeAnimated();
	const customStyles = {
		control: (base, state) => ({
			...base,
			backgroundColor: "unset",
			borderColor: !errors ? "transparent" : "#dc2626",
			boxShadow: "none",
			"&:hover": { borderColor: "transparent" },
			borderRadius: "0",
			padding: "0px",
			minHeight: "37px",
		}),
		menu: (base) => ({
			...base,
			marginTop: "4px",
			borderRadius: "8px",
			zIndex: 100,
		}),
		valueContainer: (base) => ({
			...base,
			display: "flex",
			flexWrap: "wrap",
			overflow: "hidden",
			padding: "3px",
		}),
	};
	let { pathname } = useLocation();
	const getShortPath = () => pathname.split("/").pop();

	return (
		<>
			<div className={`select-dropdown  flex-col w-100 ${FormError}`}>
				<label className="form-label w-100">{title}</label>
				<Select
					className="form-control-dropdown"
					styles={customStyles}
					closeMenuOnSelect={false}
					components={animatedComponents}
					isMulti={getShortPath(pathname) !== "route"}
					options={options}
					onBlur={onBlur}
					onChange={onChange}
					value={value}
				/>
				<div>
					{errors && touched ? (
						<div className="validation">{trans(errors)}</div>
					) : (
						""
					)}
				</div>
			</div>
		</>
	);
}

export function MultiSelect({
	options,
	errors,
	touched,
	title,
	onChange,
	onBlur,
	value,
	multi,
	id,
	name,
	placeholder,
}) {
	const FormError = errors && touched ? "form-error" : "";
	return (
		<>
			<div className={`select-dropdown flex-col w-100 ${FormError}`}>
				<label className="form-label w-100">{title}</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={placeholder ?? "Select..."}
						value={value && value.length ? value : undefined}
						id={id}
						name={name}
						onBlur={onBlur}
						allowClear
						showSearch
						status={touched && (!value || value.length === 0) ? "error" : ""}
						onChange={onChange}
						filterOption={(input, option) =>
							option.text
								? option.text.toLowerCase().includes(input.toLowerCase())
								: option.label.toLowerCase().includes(input.toLowerCase())
						}
						mode={multi ? "multiple" : undefined}
						options={options}
					/>
				</Space>

				<div>
					{errors && touched ? (
						<div className="validation">{trans(errors)}</div>
					) : (
						""
					)}
				</div>
			</div>
		</>
	);
}

export function InputDriversDropdown({
	id,
	name,
	onChange,
	onBlur,
	errors,
	touched,
	value,
	formstyle,
}) {
	const FormError = errors && touched ? "form-error" : "";
	const { data } = useGetAllDriversQuery();
	//const selectedDriver = data?.find((driver) => driver.id === value);
	const driversOptions = data
		? [
				{
					label: trans("drivers"),
					options: data?.map((driver) => ({
						label: driver.name,
						value: driver.id,
					})),
				},
			]
		: [];
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError} `}>
				<label className="form-label">{trans("Driver")}</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={trans("Select Driver")}
						value={value && value.length ? value : undefined}
						id={id}
						name={name}
						onBlur={onBlur}
						options={driversOptions}
						allowClear
						showSearch
						status={touched && (!value || value.length === 0) ? "error" : ""}
						onChange={onChange}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}

export function InputNotificationType({
	id,
	name,
	onChange,
	onBlur,
	formstyle,
	value,
	title,
	errors,
	touched,
}) {
	const FormError = errors && touched ? "form-error" : "";
	const notificationsOptions = [
		{
			label: trans("Type"),
			options: [
				{ label: trans("Speed limit exceeded"), value: "deviceOverspeed" },
				{ label: trans("Geofence entered"), value: "geofenceEnter" },
				{ label: trans("Geofence exited"), value: "geofenceExit" },
				{ label: trans("Fuel drop"), value: "deviceFuelDrop" },
				{ label: trans("Fuel increase"), value: "deviceFuelIncrease" },
			],
		},
	];
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError}`}>
				<label className="form-label">{title}</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={trans("Select...")}
						value={value && value.length ? value : undefined}
						id={id}
						name={name}
						onBlur={onBlur}
						options={notificationsOptions}
						allowClear
						showSearch
						status={touched && (!value || value.length === 0) ? "error" : ""}
						onChange={onChange}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>
				<div>
					{errors && touched ? (
						<div className="validation">{trans(errors)}</div>
					) : (
						""
					)}
				</div>
			</div>
		</>
	);
}

export function InputLanguage({
	id,
	name,
	onChange,
	onBlur,
	errors,
	touched,
	formstyle,
	value,
}) {
	const FormError = errors && touched ? "form-error" : "";

	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError} `}>
				<label className="form-label">Language</label>
				<select
					className="form-select"
					id={id}
					name={name}
					onBlur={onBlur}
					onChange={onChange}
					value={value || ""}
				>
					<option value="" disabled>
						Select Language
					</option>
					<option value="Gas">English</option>
					<option value="Diesel">Arabic</option>
				</select>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}

export function TextAreaInput({
	title,
	name,
	errors,
	touched,
	placeholder,
	formstyle,
	id,
	value,
	onChange,
	onBlur,
	rows,
	disabled = false,
	required = false,
}) {
	const FormError = errors && touched ? "form-error" : "";
	return (
		<div
			className={`position-relative vehicle-input ${formstyle} ${FormError}`}
		>
			<label className="form-label">{title}</label>
			<TextArea
				name={name}
				value={value}
				id={id}
				placeholder={placeholder}
				rows={rows ? rows : 2}
				onChange={onChange}
				onBlur={onBlur}
				disabled={disabled}
				style={{ borderColor: errors && touched && "#dc2626" }}
				autoSize={{ minRows: 3, maxRows: 3 }}
				draggable={false}
				required={required}
			/>
			<div>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</div>
	);
}

export function InputCategoriesType({
	id,
	name,
	onChange,
	onBlur,
	formstyle,
	value,
	title,
	errors,
	touched,
}) {
	const FormError = errors && touched ? "form-error" : "";
	let { data } = useGetCategoriesListQuery();
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError}`}>
				<label className="form-label">{title}</label>
				<select
					className="form-select"
					id={id}
					name={name}
					onBlur={onBlur}
					onChange={onChange}
					value={value || ""}
				>
					<option value="" disabled>
						Select Category
					</option>
					{data?.data?.map((i) => (
						<>
							<option value={i.id}>
								{i.code} / {i.name}
							</option>
						</>
					))}
				</select>

				<div>
					{errors && touched ? (
						<div className="validation">{trans(errors)}</div>
					) : (
						""
					)}
				</div>
			</div>
		</>
	);
}

export function InputSubCategoriesType({
	id,
	name,
	onChange,
	onBlur,
	formstyle,
	value,
	title,
	errors,
	touched,
	catId,
}) {
	const FormError = errors && touched ? "form-error" : "";
	let { data } = useGetSubCategoriesListQuery(catId);

	if (!catId)
		return (
			<div className={`position-relative  ${formstyle} ${FormError}`}>
				<label className="form-label">{title}</label>
				<select
					className="form-select"
					id={id}
					name={name}
					onBlur={onBlur}
					onChange={onChange}
					value={value || ""}
					disabled={true}
				>
					<option value="">Select Sub-Category</option>
				</select>

				<div>
					{errors && touched ? (
						<div className="validation">{trans(errors)}</div>
					) : (
						""
					)}
				</div>
			</div>
		);
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError}`}>
				<label className="form-label">{title}</label>
				<select
					className="form-select"
					id={id}
					name={name}
					onBlur={onBlur}
					onChange={onChange}
					value={value || ""}
				>
					<option value="" disabled>
						Select Type
					</option>
					{data?.data?.subcategory?.map((i) => (
						<option key={i.id} value={i.id}>
							{i.code} / {i.name}
						</option>
					))}
				</select>

				<div>
					{errors && touched ? (
						<div className="validation">{trans(errors)}</div>
					) : (
						""
					)}
				</div>
			</div>
		</>
	);
}

export function InputPartsType({
	id,
	name,
	onChange,
	onBlur,
	formstyle,
	value,
	title,
	errors,
	touched,
	disabled,
}) {
	const FormError = errors && touched ? "form-error" : "";

	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError}`}>
				<label className="form-label">{title}</label>
				<select
					className="form-select"
					id={id}
					name={name}
					onBlur={onBlur}
					onChange={onChange}
					value={value || ""}
					disabled={disabled}
				>
					<option value="" disabled>
						Select Type
					</option>
					<option value="Part1">Part1</option>
					<option value="Part-2">Part-2</option>
					<option value="Part-3">Part-3</option>
				</select>

				<div>
					{errors && touched ? (
						<div className="validation">{trans(errors)}</div>
					) : (
						""
					)}
				</div>
			</div>
		</>
	);
}

export function InputGroups({
	id,
	name,
	onChange,
	onBlur,
	formstyle,
	value,
	title,
	errors,
	touched,
	mode,
}) {
	//const inf = useSelector((state) => state.users.user);
	const FormError = errors && touched ? "form-error" : "";
	let { data } = useGetGroupsQuery();
	let { isEditing, currentGroupId } = useContext(popupcontext);
	const groupOptions = data
		? [
				{
					label: trans("Groups"),
					options: [
						{ label: "Ungrouped Vehicles", value: "0" },
						...data
							?.filter((i) => !(isEditing && i.id === currentGroupId))
							.map((j) => ({
								label: `${j.name}${
									Object.keys(j.attributes).length > 0 &&
									j.attributes?.code &&
									j.attributes.code !== ""
										? ` - ${j.attributes.code}`
										: ""
								}`,
								value: j.id,
							})),
					],
				},
			]
		: [];

	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError}`}>
				<label className="form-label">{title}</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={trans("Select Group")}
						value={value && value ? value : undefined}
						id={id}
						name={name}
						mode={mode && "multiple"}
						onBlur={onBlur}
						options={groupOptions}
						allowClear
						showSearch
						status={touched && (!value || value.length === 0) ? "error" : ""}
						onChange={onChange}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</Space>

				<div>
					{errors && touched ? (
						<div className="validation">{trans(errors)}</div>
					) : (
						""
					)}
				</div>
			</div>
		</>
	);
}

export function InputPermissions({
	id,
	name,
	onChange,
	onBlur,
	formstyle,
	value,
	title,
	type,
	errors,
	touched,
	data,
	mode,
	disabled,
	onClear,
}) {
	const FormError = errors && touched ? "form-error" : "";
	console.log("errors", errors, "touched", touched);
	return (
		<>
			<div className={`position-relative  ${formstyle} ${FormError} `}>
				<label className="form-label">{title}</label>
				<Space style={{ width: "100%" }} direction="vertical">
					<SelectAntd
						style={{ width: "100%" }}
						maxTagCount="responsive"
						placeholder={trans(`Select ${type}`)}
						id={id}
						name={name}
						onBlur={onBlur}
						options={data}
						allowClear
						showSearch
						status={touched && (!value || value.length === 0) ? "error" : ""}
						onChange={onChange}
						filterOption={(input, option) =>
							option.label.toLowerCase().includes(input.toLowerCase())
						}
						mode={mode}
						value={value}
						disabled={disabled}
						onClear={onClear}
					/>
				</Space>
				{errors && touched ? (
					<div className="validation">{trans(errors)}</div>
				) : (
					""
				)}
			</div>
		</>
	);
}
